import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions } from "../../contexts/auth/slice";

/**
 * Hook for embed authentication via token in URL query params.
 * Reads ?token=<jwt> from the URL, stores it in localStorage,
 * and dispatches Redux actions to set auth state.
 * Token validation is handled by the API server.
 */
const useEmbedAuth = () => {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      setError("No authentication token provided. Access denied.");
      setIsReady(true);
      return;
    }

    // Store token for axios interceptor to pick up
    localStorage.setItem("kc_token", token);

    // Set Redux auth state so axios interceptor attaches the token
    dispatch(actions.setAuthFlow("keycloak"));
    dispatch(actions.setSSOUser({ embed: true }));
    dispatch(actions.setKeycloakReady(true));
    dispatch(actions.fetchLoggedInUser());

    setIsReady(true);
  }, [dispatch]);

  // Listen for token refresh from parent window via postMessage
  useEffect(() => {
    const handleMessage = (event) => {
      // Only accept messages from expected parent origins
      // const allowedOrigins = ["https://client.example.com"];
      // if (!allowedOrigins.includes(event.origin)) return;

      if (event.data?.type === "REFRESH_TOKEN" && event.data?.token) {
        localStorage.setItem("kc_token", event.data.token);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return { isReady, error };
};

export default useEmbedAuth;
